import React from 'react';
import { usePreviewFetch } from '../hooks';
import { PreviewRouteLoaderProps } from '../types';
import LoadingState from './LoadingState';
import ErrorState from './ErrorState';
import PreviewLoadedContent from './PreviewLoadedContent';

const PreviewRouteLoader: React.FC<PreviewRouteLoaderProps> = ({
  children,
}) => {
  const { isLoading, error, previewData } = usePreviewFetch();

  if (isLoading) {
    return <LoadingState />;
  }

  if (error || !previewData) {
    return <ErrorState error={error || 'No preview data available'} />;
  }

  return (
    <PreviewLoadedContent data={previewData}>{children}</PreviewLoadedContent>
  );
};

export default PreviewRouteLoader;
